import React, { useEffect, useMemo } from 'react'
import { atom, useRecoilState } from 'recoil'
import { StaticImage } from 'gatsby-plugin-image'

import './liveagent.scss'

const liveAgentButtonState = atom({
  key: 'liveAgentButtonState',
  default: null
})

export const LiveAgent = () => {
  const [buttonState, setButtonState] = useRecoilState(liveAgentButtonState)
  const isOnline = useMemo(() => buttonState === 'BUTTON_AVAILABLE' || buttonState === 'BUTTON_ACCEPTED', [buttonState])

  useEffect(() => {
    if (!window || !window.liveagent) {
      return
    }

    if (!window._laq) {
      window._laq = []
    }

    if (window._laq.length === 0) {
      window._laq.push(function () {
        window.liveagent.showWhenOnline('573900000000Fso', document.getElementById('liveagent_button_online_573900000000Fso'))
        window.liveagent.showWhenOffline('573900000000Fso', document.getElementById('liveagent_button_offline_573900000000Fso'))
      })
    }

    if (buttonState === null) {
      window.liveagent.init('https://d.la1-c1-hnd.salesforceliveagent.com/chat', '572900000000FPQ', '00D90000000JTJX')
      window.liveagent.addButtonEventHandler('573900000000Fso', function (e) {
        setButtonState(e)
      }) 
    }
  }, [])

  const onClickHandler = () => {
    if (buttonState === 'BUTTON_AVAILABLE' || buttonState === 'BUTTON_ACCEPTED') {
      window.liveagent.startChat('573900000000Fso')
    }
  }

  return (
    <>
      <a onClick={() => onClickHandler()}>
        <div className="fixed-chat">
          <div className="chat-status">
            {isOnline ? (
              <button className="chat-btn">
                <StaticImage
                  src="../../images/chat_button_online.png"
                  alt="Livechat"
                  width={188}
                  height={55}
                  quality={100}
                  placeholder="blurred"
                  layout="fixed" />
                <span>Chat Online</span>
              </button>
            ) : (
              <button className="chat-btn">
                <StaticImage
                  src="../../images/chat_button_offline.png"
                  alt="Livechat"
                  width={188}
                  height={55}
                  quality={100}
                  placeholder="blurred"
                  layout="fixed" />
                <span>Chat Offline</span>
              </button>
            )}
          </div>
        </div>
      </a>
      <div id="liveagent_button_online_573900000000Fso"></div>
      <div id="liveagent_button_offline_573900000000Fso"></div>
    </>
  )
}

export default LiveAgent